declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

interface GoogleDataLayer {
  project: string;
  event: string;
  js: Date;
  utm_source: string;
  utm_medium: string | null;
}

export const pushGoogleAnalytics = (data: GoogleDataLayer) => {
    // Init window.dataLayer if not exist
    window.dataLayer = window.dataLayer || [];

    // Push data into dataLayer
    window.dataLayer.push(data);
};
